/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    bool, func, object, string,
} from 'prop-types';

// Material UI
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    root: {
        margin: 0,
    },
    forceExactDayRoot: {
        margin: 0,
        padding: '20px 0',
        width: '100%',
        [theme.breakpoints.down(670)]: {
            '&>span': {
                fontSize: '0.88em',
            },
        },
        [theme.breakpoints.down(408)]: {
            padding: '10px 0',
            '&>span': {
                fontSize: '0.75em',
            },
        },
    },
    checkbox: {
        fontSize: '0.8em',
        width: '16px',
        height: '16px',
        border: '0',
        padding: '0',
        borderRadius: '4px',
        margin: '5px 9px 5px 5px',
        '& svg': {
            maxWidth: '24px',
            fontSize: '24px',
            color: '#9D9D9D',
        },
    },
    checkboxChecked: {
        fontSize: '0.8em',
        width: '16px',
        height: '16px',
        border: '0',
        padding: '0',
        borderRadius: '4px',
        margin: '5px 9px 5px 5px',
        '& svg': {
            maxWidth: '24px',
            fontSize: '24px',
            color: '#058942',
        },
    },
});

const ExactDay = ({
    calendarDateType,
    forceExactDay,
    classes,
    guaranteedCharge,
    onChangeForceExactDay,
}) => {
    const showForceDelivery = (
        calendarDateType === 'between'
        && guaranteedCharge && guaranteedCharge !== 'null'
    );

    if (showForceDelivery) {
        return (
            <Grid id="exact-day" container className={classes.root}>
                <FormControlLabel
                    className={classes.forceExactDayRoot}
                    control={(
                        <Checkbox
                            checked={forceExactDay}
                            value="exactDayDelivery"
                            color="primary"
                            onChange={onChangeForceExactDay}
                            classes={{
                                root: classes.checkbox,
                                checked: classes.checkboxChecked,
                            }}
                        />
                    )}
                    label={`Exact Day Delivery + $${guaranteedCharge}`}
                />
            </Grid>
        );
    }

    return null;
};

ExactDay.propTypes = {
    calendarDateType: string.isRequired,
    classes: object.isRequired,
    forceExactDay: bool.isRequired,
    guaranteedCharge: string.isRequired,
    onChangeForceExactDay: func.isRequired,
};

export default withStyles(styles)(ExactDay);
